module.exports = __webpack_public_path__ + "static/media/01_Onboarding.93d47d2b.svg";